import gql from 'graphql-tag'

export const eventListFragment = gql`
  fragment eventList on ActiveEvent {
    id
    slug
    name
    isHighlighted
    imageUrl
    startDate
    endDate
    availableTicketsCount
    artists {
      id
      name
      avatar
    }
    country {
      code
    }
    uri {
      path
    }
    location {
      id
      name
      city {
        id
        name
      }
    }
    __typename
  }
`
